export default "__VITE_ASSET__06055061__"